// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__G1h8z","footer":"ModalFilter_footer__1NIUh"};